import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as moment from 'moment';
import 'moment-precise-range-plugin';
import { toast } from 'react-toastify';
import LogoutModel from './LogoutModel';
import DocumentVerificationModal from './DocumentVerificationModal';
import { verifyInternationalDocumentCredential, searchCredential } from '../ReduxState';
import { fncGetBookingFromState, fncDeleteTravelDocument, fncGetPassengerDocumentByKey, fncGetPassengerDocuments, fncUpdatePassengerDocuments, fncAddPassengerDocuments } from '../Utility/ApiCall.js';
import { fncPageNavigations, mergedArrayForCountryDropdown, validInternationalDocumentType, internationalDocumentType, fncAssignSearchedCheckboxes, passportValidationProperties, countryCodes3to2Converter, shortcutKeyForPage, shortcutKeys, checkPassengerStatus, isInternationalFlight, haveTravelDocs, checkinModule, fncCheckSearchedFlightDetailsEmpty, shortcutKeysForPageNavigation, shortcutKeysforHumburgerMenu } from '../Utility/CommonFun.js';
import '../Scss/_security.scss';
function Security({ handleSideMenu }) {
    const dispatch = useDispatch();
    let port;
    // let passportString = '';
    var textEncoder, writableStreamClosed, writer, historyIndex = -1;
    const notify = (e, close = 5000) =>
        toast.error(e, {
            position: "top-right",
            autoClose: close,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    const notifySuccess = (e, close = 5000) =>
    toast.success(e, {
        position: "top-right",
        autoClose: close,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
    });

    const [triggerModal, settriggerModal] = useState(false);
    const titleArr =['Mr', 'Miss', 'Mrs'];
    let history = useHistory();
    const location = useLocation();
    const docVerified = useSelector(state => state.docVerify.documentsVerified);
    const selectedModule = useSelector(state => state.login.Module);
    const UserRights = useSelector(state => state.login.CheckInRights);
    const SearchedSelectedPassengerData = useSelector(state => state.selectedpassenger.SelectedPassengerData);
    const IsLogin = useSelector(state => state.login.IsLogin);
    const stSearchedRecordData = useSelector(state => state.search.SearchedRecordData);
    const SearchedFlightDetails = useSelector(state => state.search.SearchedFlightDetails);
    const isDocVerified = useSelector(state => state.docVerify.documentsVerified);
    const passengersForPnr = { ...SearchedFlightDetails };
    // const travellingDate = passengersForPnr.journeys[0].designator.departure;
    const passengerArr = passengersForPnr.passenger.filter(p => p.IsSelected);
    let selectedPassengers = passengerArr;
    // // console.log('passengerArr.some(p => p.infant)', passengerArr.some(p => p.infant));
    if (passengerArr.some(p => p.infant)) {
        const infants = passengerArr.filter(p => p.infant);
        infants.forEach(inf => {
            const infant = inf.infant;
            infant.associatedWithPassenger = inf.passengerKey;
            infant.IsSelected = true;
            selectedPassengers.push(infant);
        });
    }

    const newarr = [];

    const infantsInArray = selectedPassengers.filter(p => p.associatedWithPassenger);
    // console.log('infantsInArray', infantsInArray);
    selectedPassengers.forEach((item, i) => {
        if (item.passengerKey && item.infant) {
            const inf = infantsInArray.find(inf => inf.associatedWithPassenger === item.passengerKey);
            if (inf) {
            newarr.push(inf)
            }
        }
        newarr.push(selectedPassengers[i]);
    });
    selectedPassengers = newarr.slice(0, newarr.length - infantsInArray.length);
    // console.log('a', selectedPassengers);
    if (infantsInArray.length) {
        let temp = 0;
        if (selectedPassengers.length % 2 === 1) {
            
            for (let i = 0; i < selectedPassengers.length - 1; i = i + 2) {
            temp = selectedPassengers[i];
            selectedPassengers[i] = selectedPassengers[i + 1];
            selectedPassengers[i + 1] = temp;
            }
        } else if (selectedPassengers.length % 2 === 0) {
            for (let i = 0; i < selectedPassengers.length; i = i + 2) {
            temp = selectedPassengers[i];
            selectedPassengers[i] = selectedPassengers[i + 1];
            selectedPassengers[i + 1] = temp;
            }
        }
    }

    let allCheckedIn = false;

    if (!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule) {
      const passengersForPnr = { ...SearchedFlightDetails };
      const passengerArr = passengersForPnr.passenger.filter(p => p.IsSelected);
      let selectedPassengers = passengerArr;
      allCheckedIn = selectedPassengers.filter(p => p.passengerKey).every(p => checkPassengerStatus(SearchedFlightDetails, SearchedSelectedPassengerData, p));
    }

    const [documentTab, setDocumentTab] = useState('travelDocument');
    const [selectedPaxIndex, setSelectedPaxIndex] = useState(0);
    // const [readcount, setReadcount] = useState(0);
    const [countryofResidence, setCountryofResidence] = useState('');
    const [issuingCountry, setIssuingCountry] = useState('');
    const [nameOnDocumentFirst, setnameOnDocumentFirst] = useState('');
    const [nameOnDocumentLast, setnameOnDocumentLast] = useState('');
    const [nameOnDocumentMiddle, setnameOnDocumentMiddle] = useState('');
    const [nameOnDocumentTitle, setnameOnDocumentTitle] = useState('');
    const [updateFirst, setupdateFirst] = useState('');
    const [updateTitle, setupdateTitle] = useState('');
    const [updateLast, setupdateLast] = useState('');
    const [updateMiddle, setupdateMiddle] = useState('');
    // const [nameOnDocument, setnameOnDocument] = useState('');
    const [gender, setgender] = useState('');
    const [docNumber, setDocNumber] = useState('');
    const [birthCountry, setbirthCountry] = useState('');
    const [nationality, setnationality] = useState('');
    const [docType, setdocType] = useState('');
    const [expirationDate, setexpirationDate] = useState('');
    const [dob, setDob] = useState('');
    const [inTransit, setinTransit] = useState('No');
    // const [pscan, setpscan] = useState('');
    // const [isDocumentVerified, setDocumentVerified] = useState(false);
    // const[idvcount, setidvcount] = useState(0);
    const [isNextDisabled, setisNextDisabled] = useState(true); 
    const [disableCrudButtons, setdisableCrudButtons] = useState(true);
    const [currentPax, setcurrentPax] = useState(selectedPassengers.length ? selectedPassengers[selectedPaxIndex] : null);
    const [whichPassennger, setwhichPassennger] = useState('');
    const [editTD, setEditTD] = useState(false);
    const [tdIndex, settdIndex] = useState(0);
    // const [documentSteps, setdocumentSteps] = useState(1);

    const countryOfResidenceArray = mergedArrayForCountryDropdown;
    const issuingCountryArray = mergedArrayForCountryDropdown;
    // const expirationArray = mergedArrayForCountryDropdown;
    const birthCountryArray = mergedArrayForCountryDropdown;
    const nationalityArray = mergedArrayForCountryDropdown;
    // console.log('selectedPassengers----', selectedPassengers, selectedPaxIndex, selectedPassengers[selectedPaxIndex]);
    // console.log('pscann value', whichPassennger);
    // console.log('td daata', tdIndex, docType, docNumber) //selectedPassengers, disableCrudButtons, isNextDisabled

    useEffect(() => {
        if (fncCheckSearchedFlightDetailsEmpty(SearchedFlightDetails)) {
            history.push('/Search');
        }
    });

    useEffect(() => {
        const allCheckedIn = selectedPassengers.filter(p => p.passengerKey).every(p => checkPassengerStatus(SearchedFlightDetails, SearchedSelectedPassengerData, p));
        if (allCheckedIn) {
            setdisableCrudButtons(true);
        } else {
            setdisableCrudButtons(false);
        }
    }, []);

    
    let r = '';
    async function appendToTerminal(newStuff) {
        // alert(newStuff);
        // let serialResultsDiv = document.getElementById("scannedValue");
        // serialResultsDiv.innerHTML = serialResultsDiv.innerHTML + newStuff;
        r = r + newStuff

        // const data=serialResultsDiv.textContent.split(" 100")
        const data = r.split(" 100")

        // if(newStuff.length>3)
        //    {
        //     console.log("data:"+data[data.length-2].replace(/\uFFFD/g, ' '))
        //     var i=0
        //     while(i<=200){
        //         console.log("timer"+i)
        //         await sleep(1000)
        //         i++
        //     }     

        // }


        if (newStuff.length > 3) {

            // console.log(data[data.length - 2]);
            if(data.length>1)
                var finalScanData = data[data.length - 2].trim();
                if (finalScanData !== undefined)
                console.log("timer ---" ,finalScanData)
            
            else 
            console.log("timerelse ---", data[0], data[0].length, data[0].length % 94);
            if (data[0].length === 94 || data[0].length % 94 === 0) {
                let scanString = `${data[0]}`;
                const sub = scanString.length/94
                scanString = scanString.substr(94*(sub-1), 94)
                // const scanString = `${data[0]}`;
                const doctype = scanString.substr(2,1)
                const issuingcountry = scanString.substr(4,3);
                const name = scanString.substr(7,39).split('<<')
                const first = name[1];
                const last = name[0];
                const passportnum = scanString.substr(47,8)
                const nationality = scanString.substr(57,3)
                const gender = scanString.substr(67,1)
                const dobYYMMDD = scanString.substr(60, 6)
                const doby = dobYYMMDD.substr(0,2);
                const dobdate = moment(doby, "YY");
                const dobyear = dobdate.format("YYYY");
                const expiryDateYYMMDD = scanString.substr(68,6)
                const expiry = expiryDateYYMMDD.substr(0,2);
                const expirydate = moment(expiry, "YY");
                const expiryyear = expirydate.format("YYYY");
                console.log(
                    'dooctype:', doctype,
                    '\nissue country:',issuingcountry,
                    '\nfirst name:', first,
                    '\nlast name:',last,
                    '\nvisa number:',passportnum,
                    '\nnationality:', nationality,
                    '\ndob:', dobYYMMDD,
                    '\ngender:' ,gender,
                    '\nexpiry date:' ,expiryDateYYMMDD
                );
                setdocType(internationalDocumentType.find(t => t.code === doctype).label);
                setDocNumber(passportnum);
                setnationality(countryCodes3to2Converter.find(c => c['3DigitCode'] === nationality).COUNTRY_NAME);
                setIssuingCountry(countryCodes3to2Converter.find(c => c['3DigitCode'] === issuingcountry).COUNTRY_NAME)
                setgender(gender === 'M' ? 'Male' : gender === 'F' ? 'Female' : '');
                setDob(`${dobYYMMDD.substr(4,2)}/${dobYYMMDD.substr(2,2)}/${dobyear}`);
                setexpirationDate(`${expiryDateYYMMDD.substr(4,2)}/${expiryDateYYMMDD.substr(2,2)}/${expiryyear}`);
                setupdateTitle(gender === 'M' ? 'Mr' : gender === 'F' ? 'Miss' : '');
                setupdateFirst(first.toUpperCase());
                setupdateLast(last.toUpperCase());
                setnameOnDocumentFirst(first.toUpperCase());
                setnameOnDocumentLast(last.toUpperCase());
                setnameOnDocumentTitle(gender === 'M' ? 'Mr' : gender === 'F' ? 'Miss' : '');
                // setpscan(`${data[0]}`);
            }
        }
    }
    
    async function listenToPort(port) {
        const textDecoder = new TextDecoderStream();
        const readableStreamClosed = port.readable.pipeTo(textDecoder.writable);
        const reader = textDecoder.readable.getReader();
        

        // Listen to data coming from the serial device.
        let val = ""
        while (true) {
            const { value, done } = await reader.read();
            if (done) {
                // Allow the serial port to be closed later.
                console.log('[readLoop] DONE', done);
                // setReadcount(1);
                // reader.cancel();
                reader.releaseLock();
                // writer = textEncoder.writable.getWriter();
                break;
            }
            // if (value) {
            //     console.log('read value-', value);
            // }
            debugger
            // val=val+value
            // if(val.length>10){
            appendToTerminal(value);
            let val = ""
            // }
        }
    }

    async function fncConnectScanner() {

        // const { remote } = require('electron');
        // const { BrowserWindow, dialog, shell } = remote;
        // let printWindow = new BrowserWindow({ 'auto-hide-menu-bar': true,show:false });
        // printWindow.loadURL("www.google.com");
        // let list = printWindow.webContents.getPrinters();
        // console.log("All printer available are ",list);
        
        try {
            // Prompt user to select any serial port.
            port = await navigator.serial.requestPort();
            await port.open({ baudRate: 9600 });
            let settings = {};
    
            if (localStorage.dtrOn == "true") settings.dataTerminalReady = true;
            if (localStorage.rtsOn == "true") settings.requestToSend = true;
            if (Object.keys(settings).length > 0) await port.setSignals(settings);
    
    
            textEncoder = new TextEncoderStream();
            writableStreamClosed = textEncoder.readable.pipeTo(port.writable);
            writer = textEncoder.writable.getWriter();
            await listenToPort(port);
        } catch (e) {
            console.log("Serial Connection Failed" + e);
        }
    }

    useEffect(() => {
        /** check for all the passengers if they have document with all the properties */
        debugger
        for(let i=0; i < selectedPassengers.length; i++) {
            if (selectedPassengers[i].traveldocuments && selectedPassengers[i].traveldocuments.length) {
                for(let j=0; j < selectedPassengers[i].traveldocuments.length; j++) {
                    if (!getVerificationIcon(selectedPassengers[i], selectedPassengers[i].traveldocuments[j])) {
                        setisNextDisabled(true);
                        break;
                    } else {
                        setisNextDisabled(false);
                    }
                }
            } else {
                setisNextDisabled(true);
            }
        }
    }, []); //isNextDisabled

    /** effect for opening/closing side menu using shortcut keys (ALT + e)  */
    useEffect(() => {
        document.addEventListener("keydown", function (event) {  
          if (event.altKey && (event.key === 'Dead' || event.key === 'e')) {
            handleSideMenu();
          }
        })
    });

    useEffect(() => {
             const handleKeyDown = (e) => {
               if (e.ctrlKey && e.key === "ArrowLeft") {
                 history.goBack();
               }
             };  
               document.addEventListener("keydown", handleKeyDown);  
             return () => {
               document.removeEventListener("keydown", handleKeyDown);
             };
           }, [history]);

    useEffect(() => {
             const handleKeyDown = (e) => {
               if (e.ctrlKey && e.key === "ArrowRight") {
               fncNextSecurity();
              }
             };  
               document.addEventListener("keydown", handleKeyDown);  
             return () => {
               document.removeEventListener("keydown", handleKeyDown);
             };
           }, [history]);

    useEffect(() => {
              document.addEventListener("keydown", shortcutKeyHandler);
              return () => {
                  document.removeEventListener('keydown', shortcutKeyHandler);
              };
          });
      
          const shortcutKeyHandler = (event) => {
              const tag = event.target.tagName.toLowerCase();
              const isTypingField = tag === 'input' || tag === 'textarea' || event.target.isContentEditable;
              if(shortcutKeysForPageNavigation.includes(event.key)){
                  const path = shortcutKeyForPage(location.pathname, event, SearchedFlightDetails);
                  if (path) {
                      history.push('/' + path);
                  }
              }
              if (isTypingField && !event.ctrlKey) return;
              if (event.ctrlKey  && shortcutKeys.includes(event.key)) {
                  if (shortcutKeysforHumburgerMenu.includes(event.key)) {
                          dispatch(redirectToPageCredentials(
                                      {
                                        type: "",
                                        redirectionPage: location.pathname
                                      }
                           ));
                  }
                  const path = shortcutKeyForPage(location.pathname, event);
                  if (path) {
                      history.push('/' + path);
                  }
              }                          
          }

    useEffect(() => {
        debugger
        // initialSetup();
        if(currentPax) {
            // // console.log('currentPax', currentPax);
            // setDocumentVerified(currentPax.idv);
            if (((currentPax.travelDocuments && currentPax.travelDocuments.length)
            || (currentPax.traveldocuments && currentPax.traveldocuments.length))
            && whichPassennger === ''
            ) {
                const traveldocuments  = currentPax.travelDocuments ? currentPax.travelDocuments : currentPax.traveldocuments;
                const paxDoc  = traveldocuments.filter(td => validInternationalDocumentType.includes(td.documentTypeCode));
                if (paxDoc.length) {
                    debugger
                    const getlabel = internationalDocumentType.find(idt => idt.code === paxDoc[0].documentTypeCode);
                    const getissuingCountry = issuingCountryArray.find(ic => ic.code === paxDoc[0].issuedByCode);
                    const getnationality = nationalityArray.find(ic => ic.code === paxDoc[0].nationality);
                    const getbirthCountry = birthCountryArray.find(bc => bc.code === paxDoc[0].birthCountry);
                    // const { name } = paxDoc[0];
                    //moment(segmentForTable.designator.departure).format("D MMM, YYYY")
                    setDob(paxDoc[0].dateOfBirth ? moment(paxDoc[0].dateOfBirth).format("DD/MM/YYYY") : '');
                    setexpirationDate(paxDoc[0].expirationDate ? moment(paxDoc[0].expirationDate).format("DD/MM/YYYY") : '');
                    setnameOnDocumentFirst(paxDoc[0].name && paxDoc[0].name.first ? paxDoc[0].name.first : '');
                    setnameOnDocumentLast(paxDoc[0].name && paxDoc[0].name.last ? paxDoc[0].name.last : '');
                    setnameOnDocumentMiddle(paxDoc[0].name && paxDoc[0].name.middle ? paxDoc[0].name.middle : '');
                    setupdateFirst(paxDoc[0].name && paxDoc[0].name.first ? paxDoc[0].name.first : '');
                    setupdateLast(paxDoc[0].name && paxDoc[0].name.last ? paxDoc[0].name.last : '');
                    setupdateMiddle(paxDoc[0].name && paxDoc[0].name.middle ? paxDoc[0].name.middle : '');
                    setupdateTitle(paxDoc[0].name && paxDoc[0].name.title ? paxDoc[0].name.title : '');
                    setnameOnDocumentTitle(paxDoc[0].name && paxDoc[0].name.title ? paxDoc[0].name.title : '');
                    // setnameOnDocument(paxDoc[0].name ? `${paxDoc[0].name.last}, ${paxDoc[0].name.first} ${paxDoc[0].name.title ? paxDoc[0].name.title : ''}` : '');
                    setDocNumber(paxDoc[0].number ? paxDoc[0].number : '');
                    setgender(paxDoc[0].gender ? paxDoc[0].gender : '');
                    setnationality(getnationality ? getnationality.name : '');
                    setbirthCountry(getbirthCountry ? getbirthCountry.name : '');
                    setIssuingCountry(getissuingCountry ? getissuingCountry.name : '');
                    setdocType(getlabel.label ? getlabel.label : 'Passport');
                    // setDocumentVerified(paxDoc[0].isDocVerified);
                }
            } else {
                setdocType('Passport');
                setupdateTitle('Mr');
                setDob('');
                setexpirationDate('');
                setnameOnDocumentFirst('');
                setnameOnDocumentLast('');
                setnameOnDocumentMiddle('');
                setupdateFirst('');
                setupdateLast('');
                setupdateMiddle('');
                setnameOnDocumentTitle('');
                setDocNumber('');
                setgender('');
                setnationality('');
                setbirthCountry('');
                setIssuingCountry('');

            }
        }
    }, [currentPax, whichPassennger]); //currentPax, selectedPassengers

    // const fncDocVerification = (e) => {
    //     const validationArray = [nameOnDocumentFirst,
    //         issuingCountry,
    //         gender,
    //         docNumber,
    //         birthCountry,
    //         nationality,
    //         docType,
    //         expirationDate,
    //         dob];
    //         if (e.target.checked) {
    //             if (validationArray.includes('')) {
    //                 notify('Pleasse fill out all the fields');
    //             } else {
    //                 setDocumentVerified(e.target.checked);
    //                 dispatch(verifyInternationalDocumentCredential(
    //                     {
    //                         type: "",
    //                         isInternationalDocumentVerified: e.target.checked,
    //                     }))
    //             }
    //         } else {
    //             setDocumentVerified(e.target.checked);
    //             dispatch(verifyInternationalDocumentCredential(
    //                 {
    //                     type: "",
    //                     isInternationalDocumentVerified: e.target.checked,
    //                 }))
    //         }
        
        
    // }

    const validateAllProperties = () => {
        const returnObj = {
            isValid: true
        }
        const validFeilds = {
            firstName: nameOnDocumentFirst,
            lastName: nameOnDocumentLast,
            issuingCountry,
            gender,
            docNumber,
            birthCountry,
            nationality,
            docType,
            expirationDate,
            dob
        }
        const keys = Object.keys(validFeilds);
        keys.forEach((key, i) => {
            if (validFeilds[key] === '' || !validFeilds[key]) {
                // console.log('key', key)
                returnObj.isValid = false;
                returnObj.msg = `Please enter ${passportValidationProperties[key]} for the passenger`;
            }
            let segmentDeparture;
            SearchedFlightDetails.journeys.forEach((jou, j) => {
                jou.segments.forEach((seg, i) => {
                    if (seg.segmentKey === SearchedSelectedPassengerData.SelectedSegmentKey[0]) {
                        segmentDeparture = seg.designator.departure;
                    }
                }) 
            })
            /** fix for 14. DOB or expiry date is accepting any invalid date which is in correct. */
            var date_regex = /^(0[1-9]|1\d|2\d|3[01])\/(0[1-9]|1[0-2])\/(19|20)\d{2}$/;

            if (returnObj.isValid && key === 'expirationDate') {
                if (date_regex.test(validFeilds[key])) { //(validFeilds[key].length === 10) {
                    const expiryDate = moment(validFeilds[key],'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss');
                    console.log('expiryDate', expiryDate, 'departure', segmentDeparture);
                    if (expiryDate < segmentDeparture) {
                        returnObj.isValid = false;
                        returnObj.msg = 'Travel document is expired before departure date';
                    }
                } else {
                    returnObj.isValid = false;
                    returnObj.msg = 'Invalid expiration date';
                }
            }
            if (returnObj.isValid && key === 'dob') {
                if (date_regex.test(validFeilds[key])) {
                    const paxDOB = moment(validFeilds[key],'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss');
                    const momentDep = moment(segmentDeparture);
                    const momentDOB = moment(paxDOB);
                    // const diff = momentDep.diff(momentDOB, 'years');
                    // const diffinmonth = momentDep.diff(momentDOB, 'months');
                    // const diffindays = momentDep.diff(momentDOB, 'days');
                    // const diffmonthConvertedToYear = diffinmonth/12;
                    const preciseDifference = moment.preciseDiff(momentDOB, momentDep, true);
                    // console.log('diff', diff, diffinmonth, diffindays, diffinmonth/12,
                    // '\n moment.preciseDiff(m1, m2)', moment.preciseDiff(momentDOB, momentDep),
                    // '\n moment.duration(m1.diff(m2)).humanize()', moment.duration(momentDOB.diff(momentDep)).humanize(),
                    // '\n moment.preciseDiff(m1, m2, true)', moment.preciseDiff(momentDOB, momentDep, true));
                    // console.log('preciseDifference', preciseDifference.years, preciseDifference.months, preciseDifference.days);
                    if (selectedPassengers[selectedPaxIndex].associatedWithPassenger) {
                        /** infant less than two years */
                        if (preciseDifference.years >= 2) {
                            returnObj.isValid = false;
                            returnObj.msg = `Infant's age should be less than two years old.`;
                        }
                    } else {
                        debugger
                        if (selectedPassengers[selectedPaxIndex].passengerTypeCode === 'CHD') {
                            /** child (2-12) both ends including */
                            if ((preciseDifference.years < 2)
                            ||
                            (preciseDifference.years > 12 || (preciseDifference.years === 12 && (preciseDifference.months > 0 || preciseDifference.days > 0)))
                            ) {
                                returnObj.isValid = false;
                                returnObj.msg = `Children passenger's age should be between (2-12) years.`;
                            }
                        }
                        if (selectedPassengers[selectedPaxIndex].passengerTypeCode === 'ADT') {
                            /** adult more than 12 years */
                            if (preciseDifference.years < 12 || (preciseDifference.years === 12 && preciseDifference.months === 0 && preciseDifference.days === 0)) {
                                returnObj.isValid = false;
                                returnObj.msg = `Adult passenger's age should be greater than 12 years.`;
                            }
                        }
                    }
                } else {
                    returnObj.isValid = false;
                    returnObj.msg = 'Invalid birth date';
                }
            }
        })
        // console.log(validFeilds, returnObj);
        return returnObj;
    }

    function fncNextSecurity() {
        var navPage = fncPageNavigations(UserRights, "SecurityTravelDoc", SearchedFlightDetails)
        history.push("/" + navPage);
    }

    function fncDocumentTypeToShow(type, td, index, pax, passengerPosition) {

        // console.log('fncDocumentTypeToShow','type', type,'td', td, 'index', index, 'pax', pax,'passengerPosition', passengerPosition);
        if (type === 'travelDocument' && td ) { // && index && pax && passengerPosition
            const getlabel = internationalDocumentType.find(idt => idt.code === td.documentTypeCode);
            const getissuingCountry = issuingCountryArray.find(ic => ic.code === td.issuedByCode);
            const getnationality = nationalityArray.find(ic => ic.code === td.nationality);
            const getbirthCountry = birthCountryArray.find(bc => bc.code === td.birthCountry);
            setDob(td.dateOfBirth ? moment(td.dateOfBirth).format("DD/MM/YYYY") : '');
            setexpirationDate(td.expirationDate ? moment(td.expirationDate).format("DD/MM/YYYY") : '');
            setnameOnDocumentFirst(td.name && td.name.first ? td.name.first : '');
            setnameOnDocumentLast(td.name && td.name.last ? td.name.last : '');
            setnameOnDocumentMiddle(td.name && td.name.middle ? td.name.middle : '');
            setupdateFirst(td.name && td.name.first ? td.name.first : '');
            setupdateLast(td.name && td.name.last ? td.name.last : '');
            setupdateMiddle(td.name && td.name.middle ? td.name.middle : '');
            setupdateTitle(td.name && td.name.title ? td.name.title : '');
            setnameOnDocumentTitle(td.name && td.name.title ? td.name.title : '');
            setDocNumber(td.number ? td.number : '');
            setgender(td.gender ? td.gender : '');
            setnationality(getnationality ? getnationality.name : '');
            setbirthCountry(getbirthCountry ? getbirthCountry.name : '');
            setIssuingCountry(getissuingCountry ? getissuingCountry.name : '');
            setdocType(getlabel.label ? getlabel.label : 'Passport');
        }
        setDocumentTab(type);
        settdIndex(index);
        if (whichPassennger !== '') {
            setwhichPassennger('');
        }
    }

    const fncChangeCOR = (e) => {
        // console.log('e.target.value COR', e.target.value);
        setCountryofResidence(e.target.value);
    }

    const fncChangeIC = (e) => {
        // console.log('e.target.value IC', e.target.value);
        setIssuingCountry(e.target.value);
    }

    const fncChangeBC = (e) => {
        // console.log('e.target.value BC', e.target.value);
        setbirthCountry(e.target.value);
    }

    const fncChangeNationality = (e) => {
        // console.log('e.target.value fncChangeNationality', e.target.value);
        setnationality(e.target.value);
    }

    const fncChangeDoctype = (e) => {
        // console.log('e.target.value fncChangeDoctype', e.target.value);
        setdocType(e.target.value);
    }

    const fncDocNumber = (e) => {
        const alphaNumeric = /^[0-9a-zA-Z]+$/;
        const value = e.target.value;
        // console.log('e.target.value fncDocNumber', e.target.value);
        if (value !== "") {
            if (value.match(alphaNumeric)) {
                if (value.length <= 20) {
                    setDocNumber(e.target.value);
                }
            }
        } else {
            setDocNumber(value);
        }
    }

    const fncChangeExpiryDate = (e) => {
        // console.log('e.target.value fncChangeExpiryDate', e.target.value, e.target.value.length);
        setexpirationDate(e.target.value);
        
    }

    const fncChangeDob = (e) => {
        // console.log('e.target.value fncChangeDob', e.target.value);
        setDob(e.target.value);
    }

    const fncChangeGender = (e) => {
        // console.log('e.target.value fncChangeGender', e.target.value);
        setgender(e.target.value);
    }

    const fncChangeCurrentPax = (index) => {
        setSelectedPaxIndex(index);
        setcurrentPax(selectedPassengers[index]);
        setEditTD(false);
    }

    const fncChangeCurrentPaxFromPopup = (e) => {
        setwhichPassennger(e.target.value);
    }

    const fncChangeName = (e) => {
        const id = e.target.id;
        const value = e.target.value;
        // console.log('id value', id, value);
        if (id === 'fname') {
            setupdateFirst(value.toUpperCase())
        }
        if (id === 'mName') {
            setupdateMiddle(value.toUpperCase())
        }
        if (id === 'lName') {
            setupdateLast(value.toUpperCase())
        }
        if (id === 'title') {
            setupdateTitle(value); //.toUpperCase()
        }
    }

    const fncAdd = () => {
        // console.log('add button updateFirst=====', updateFirst, updateLast, updateMiddle)
        if (updateFirst !== nameOnDocumentFirst) {
            setupdateFirst(updateFirst);
            setnameOnDocumentFirst(updateFirst);
        }
        if (updateLast !== nameOnDocumentLast) {
            setupdateLast(updateLast);
            setnameOnDocumentLast(updateLast);
        }
        if (updateMiddle !== nameOnDocumentMiddle) {
            setupdateMiddle(updateMiddle);
            setnameOnDocumentMiddle(updateMiddle);
        }
        if (updateTitle !== nameOnDocumentMiddle) {
            setupdateTitle(updateTitle);
            setnameOnDocumentTitle(updateTitle);
        }
    }

    const fncClear = () => {
        // console.log('clear======', nameOnDocumentFirst, nameOnDocumentMiddle, nameOnDocumentLast);
        if ((currentPax.travelDocuments && currentPax.travelDocuments.length) || (currentPax.traveldocuments && currentPax.traveldocuments.length)) {
            const traveldocuments  = currentPax.travelDocuments ? currentPax.travelDocuments : currentPax.traveldocuments;
            const paxDoc  = traveldocuments.filter(td => validInternationalDocumentType.includes(td.documentTypeCode));
            // if (paxDoc.length) {
            //     setupdateFirst(paxDoc[0].name && paxDoc[0].name.first ? paxDoc[0].name.first : '');
            //     setupdateLast(paxDoc[0].name && paxDoc[0].name.last ? paxDoc[0].name.last : '');
            //     setupdateMiddle(paxDoc[0].name && paxDoc[0].name.middle ? paxDoc[0].name.middle : '');
            // }
            setnameOnDocumentFirst('');
            setnameOnDocumentLast('');
            setnameOnDocumentMiddle('');
            setnameOnDocumentTitle('');
            setupdateFirst('');
            setupdateMiddle('');
            setupdateLast('');
        } else {
            /** bug fix for 13. In name field the option to clear is not working. */
            // setupdateFirst(nameOnDocumentFirst);
            // setupdateMiddle(nameOnDocumentMiddle);
            // setupdateLast(nameOnDocumentLast);
            setnameOnDocumentFirst('');
            setnameOnDocumentLast('');
            setnameOnDocumentMiddle('');
            setnameOnDocumentTitle('');
            setupdateFirst('');
            setupdateMiddle('');
            setupdateLast('');
        }
    }

    function handleInTransitChange(e) {
        setinTransit(e.target.value);
    }

    const fncCancelPopup = () => {
        // console.log('fncCancelPopup======')
        setwhichPassennger('');
    }

    const fncAddPassengerFromPopup = () => {
        debugger
        const index = selectedPassengers.findIndex(pax => `${pax.name.last}, ${pax.name.first} ${pax.name.title ? pax.name.title : ''}` === whichPassennger);
        if (index !== -1) {
            setSelectedPaxIndex(index);
            setcurrentPax(selectedPassengers[index]);
        } else {
            notify('Please select passenger to proceed', 2000)
        }
    }

    const fncAddUpdateTravelDocument = () => {
        // // console.log('fncAddUpdateTravelDocument', docType);
        const traveldocuments  = currentPax.travelDocuments ? currentPax.travelDocuments : currentPax.traveldocuments;
        if (validateAllProperties().isValid) {
            if (((currentPax.travelDocuments && currentPax.travelDocuments.length)
            || (currentPax.traveldocuments && currentPax.traveldocuments.length))
            && whichPassennger === ''
            ) {
                // const traveldocuments  = currentPax.travelDocuments ? currentPax.travelDocuments : currentPax.traveldocuments;
                const PaxDocs = [];
                const apiBody = [];
                const InfantDocs = [];
                const getlabel = internationalDocumentType.find(idt => idt.label === docType);
                const doc = traveldocuments.filter(td => td.documentTypeCode === getlabel.code);
                const paxBody = {
                    PassengerKey: currentPax.passengerKey ? currentPax.passengerKey : currentPax.associatedWithPassenger
                }
                if (currentPax.passengerKey) {
                    const PaxDocument = {
                        passengerTravelDocumentKey: doc[0].passengerTravelDocumentKey,
                        documentTypeCode: getlabel.code,
                        birthCountry: birthCountryArray.find(bc => bc.name.toUpperCase() === birthCountry.toUpperCase()).code,
                        issuedByCode: issuingCountryArray.find(bc => bc.name.toUpperCase() === issuingCountry.toUpperCase()).code,
                        "name":{
                            "title": nameOnDocumentTitle,
                            "first": nameOnDocumentFirst,
                            "last": nameOnDocumentLast,
                            "middle":nameOnDocumentMiddle,
                            "suffix":""
                        },
                        "nationality":nationalityArray.find(bc => bc.name.toUpperCase() === nationality.toUpperCase()).code,
                        "expirationDate": expirationDate !== '' ? moment(expirationDate,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss')  : expirationDate, //moment(new Date(expirationDate)).format()
                        "number":docNumber,
                        "issuedDate":doc[0].issuedDate ? doc[0].issuedDate : null,
                        "gender":gender ? gender : null,
                        "dateOfBirth": dob ? moment(dob,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss') : dob //moment(new Date(dob)).format()
                    }
                    PaxDocs.push(PaxDocument);
                    paxBody.PaxDocs = PaxDocs;
                }
                if (currentPax.associatedWithPassenger) {
                    const PaxDocument = {
                        passengerTravelDocumentKey: doc[0].passengerTravelDocumentKey,
                        documentTypeCode: getlabel.code,
                        birthCountry: birthCountryArray.find(bc => bc.name.toUpperCase() === birthCountry.toUpperCase()).code,
                        issuedByCode: issuingCountryArray.find(bc => bc.name.toUpperCase() === issuingCountry.toUpperCase()).code,
                        "name":{
                            "title": nameOnDocumentTitle,
                            "first": nameOnDocumentFirst,
                            "last": nameOnDocumentLast,
                            "middle":nameOnDocumentMiddle,
                            "suffix":""
                        },
                        "nationality":nationalityArray.find(bc => bc.name.toUpperCase() === nationality.toUpperCase()).code,
                        "expirationDate": expirationDate !== '' ? moment(expirationDate,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss')  : expirationDate, //moment(new Date(expirationDate)).format()
                        "number":docNumber,
                        "issuedDate":doc[0].issuedDate ? doc[0].issuedDate : null,
                        "gender":gender ? gender : null,
                        "dateOfBirth": dob ? moment(dob,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss') : dob //moment(new Date(dob)).format()
                    }
                    InfantDocs.push(PaxDocument);
                    paxBody.InfantDocs = InfantDocs;
                }
    
                if (currentPax.infant || currentPax.associatedWithPassenger) {
                    paxBody.HasInfant = true;
                } else {
                    paxBody.HasInfant = false;
                }
                apiBody.push(paxBody);
                // // console.log('apiBody', apiBody);
    
                fncUpdatePassengerDocuments(apiBody)
                .then(result => {
                    if (result.status == "401" && result.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        settriggerModal(true);
                    } else {
                        const key = currentPax.passengerKey ? currentPax.passengerKey : currentPax.associatedWithPassenger;
                        if (!result.data.isError && result.data.addpassengerdocumentresponse.find(r => r.passengerKey === key).isDocumentAdded) {
                            fncGetBookingFromState()
                            .then((returnVal) => {
                                if (returnVal.status == "401" && returnVal.data == "") {
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                    settriggerModal(true);
                                }
                                else {
    
                                    if (!returnVal.data.isError) {
                                        if (returnVal.data.flightDetails != null) {
                                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "UPDATEPAXINFO");
                                        }
                                        dispatch(searchCredential(
                                            {
                                                type: "",
                                                SearchedRecordData: stSearchedRecordData,
                                                SearchedFlightDetails: assignStateAgain
                                            }
                                        ));
                                        // setpscan('');
                                    }
                                    else {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        // console.log(returnVal.data.errorDetail);
                                        notify(returnVal.data.errorDetail.errorMessage);
                                    }
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                }
    
                            })
                            .catch(err => console.log("Axios err: ", err))
                        } else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            console.log(result.data.errorDetail);
                            notify(result.data.errorDetail.errorMessage);
                        }
                    }
                })
                .catch(err => console.log("Axios err: ", err));
                
            } else {
                const PaxDocs = [];
                const apiBody = [];
                const InfantDocs = [];
                const paxBody = {
                    PassengerKey: currentPax.passengerKey ? currentPax.passengerKey : currentPax.associatedWithPassenger
                }
                const getlabel = internationalDocumentType.find(idt => idt.label === docType);
                if (currentPax.passengerKey) {
                    const PaxDocument = {
                        // passengerTravelDocumentKey: doc[0].passengerTravelDocumentKey,
                        documentTypeCode: getlabel.code,
                        birthCountry: birthCountryArray.find(bc => bc.name.toUpperCase() === birthCountry.toUpperCase()).code,
                        issuedByCode: issuingCountryArray.find(bc => bc.name.toUpperCase() === issuingCountry.toUpperCase()).code,
                        "name":{
                            "title": nameOnDocumentTitle,
                            "first": nameOnDocumentFirst,
                            "last": nameOnDocumentLast,
                            "middle":nameOnDocumentMiddle,
                            "suffix":""
                        },
                        "nationality":nationalityArray.find(bc => bc.name.toUpperCase() === nationality.toUpperCase()).code,
                        "expirationDate": expirationDate !== '' ? moment(expirationDate,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss')  : expirationDate, //moment(new Date(expirationDate)).format()
                        "number":docNumber,
                        // "issuedDate":'',
                        "gender":gender ? gender : null,
                        "dateOfBirth": dob ? moment(dob,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss') : dob //moment(new Date(dob)).format()
                    }
                    PaxDocs.push(PaxDocument);
                    paxBody.PaxDocs = PaxDocs;
                    paxBody.InfantDocs = [];
                }
    
                if (currentPax.associatedWithPassenger) {
                    const PaxDocument = {
                        // passengerTravelDocumentKey: doc[0].passengerTravelDocumentKey,
                        documentTypeCode: getlabel.code,
                        birthCountry: birthCountryArray.find(bc => bc.name.toUpperCase() === birthCountry.toUpperCase()).code,
                        issuedByCode: issuingCountryArray.find(bc => bc.name.toUpperCase() === issuingCountry.toUpperCase()).code,
                        "name":{
                            "title": nameOnDocumentTitle,
                            "first": nameOnDocumentFirst,
                            "last": nameOnDocumentLast,
                            "middle":nameOnDocumentMiddle,
                            "suffix":""
                        },
                        "nationality":nationalityArray.find(bc => bc.name.toUpperCase() === nationality.toUpperCase()).code,
                        "expirationDate": expirationDate !== '' ? moment(expirationDate,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss')  : expirationDate, //moment(new Date(expirationDate)).format()
                        "number":docNumber,
                        // "issuedDate":'',
                        "gender":gender ? gender : null,
                        "dateOfBirth": dob ? moment(dob,'DD/MM/YYYY').format('YYYY-MM-DD[T]HH:mm:ss') : dob //moment(new Date(dob)).format()
                    }
                    InfantDocs.push(PaxDocument);
                    paxBody.InfantDocs = InfantDocs;
                }
                
                if (currentPax.infant || currentPax.associatedWithPassenger) {
                    paxBody.HasInfant = true;
                } else {
                    paxBody.HasInfant = false;
                }
                apiBody.push(paxBody);
                // // console.log('apiBody', apiBody);
    
                fncAddPassengerDocuments(apiBody)
                .then(result => {
                    if (result.status == "401" && result.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        settriggerModal(true);
                    } else if (result.status == "400") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify('Something went wrong. Please try again later.', 3000)
                    } else {
                        const key = currentPax.passengerKey ? currentPax.passengerKey : currentPax.associatedWithPassenger;
                        if (!result.data.isError && result.data.addpassengerdocumentresponse.find(r => r.passengerKey === key).isDocumentAdded) {
                            fncGetBookingFromState()
                            .then((returnVal) => {
                                if (returnVal.status == "401" && returnVal.data == "") {
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                    settriggerModal(true);
                                }
                                else {
    
                                    if (!returnVal.data.isError) {
                                        if (returnVal.data.flightDetails != null) {
                                            var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "UPDATEPAXINFO");
                                        }
                                        dispatch(searchCredential(
                                            {
                                                type: "",
                                                SearchedRecordData: stSearchedRecordData,
                                                SearchedFlightDetails: assignStateAgain
                                            }
                                        ));
                                        debugger
                                        settdIndex(traveldocuments && traveldocuments.length === 0 ? 0 : traveldocuments.length);
                                        // setpscan('');
                                    }
                                    else {
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        // console.log(returnVal.data.errorDetail);
                                        notify(returnVal.data.errorDetail.errorMessage);
                                    }
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                }
    
                            })
                            .catch(err =>  console.log("Axios err: ", err))
                        } else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            // console.log(result.data.errorDetail);
                            notify(result.data.errorDetail.errorMessage);
                        }
                    }
                })
                .catch(err => console.log("Axios err: ", err));
            }
        } else {
            notify(validateAllProperties().msg);
        }
    }

    const fncDeleteDocument = () => {
        if ((currentPax.travelDocuments && currentPax.travelDocuments.length) || (currentPax.traveldocuments && currentPax.traveldocuments.length)) {
            const traveldocuments  = currentPax.travelDocuments ? currentPax.travelDocuments : currentPax.traveldocuments;
            const apiBody = [];
            const getlabel = internationalDocumentType.find(idt => idt.label === docType);
            const doc = traveldocuments.filter(td => td.documentTypeCode === getlabel.code);

            const docBody = {
                "PassengerKey": currentPax.passengerKey ? currentPax.passengerKey : currentPax.associatedWithPassenger,
                "travelDocumentKey": doc[0].passengerTravelDocumentKey,
            }
            if (currentPax.associatedWithPassenger) { //currentPax.infant ||
                docBody.HasInfant = true;
            } else {
                docBody.HasInfant = false;
            }
            apiBody.push(docBody);
            fncDeleteTravelDocument(apiBody)
            .then(result => {
                if (result.status == "401" && result.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    settriggerModal(true);
                } else {
                    const key = currentPax.passengerKey ? currentPax.passengerKey : currentPax.associatedWithPassenger;
                    if (!result.data.isError && result.data.deletePassengerTravelDoc.find(r => r.passengerKey === key).isTravelDocDeleted) {
                        fncGetBookingFromState()
                        .then((returnVal) => {
                            if (returnVal.status == "401" && returnVal.data == "") {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                settriggerModal(true);
                            }
                            else {

                                if (!returnVal.data.isError) {
                                    if (returnVal.data.flightDetails != null) {
                                        var assignStateAgain = fncAssignSearchedCheckboxes(SearchedSelectedPassengerData, returnVal.data.flightDetails, "UPDATEPAXINFO");
                                        
                                        // initialSetup()
                                    }
                                    dispatch(searchCredential(
                                        {
                                            type: "",
                                            SearchedRecordData: stSearchedRecordData,
                                            SearchedFlightDetails: assignStateAgain
                                        }
                                    ));
                                    setdocType('');
                                    // setpscan('');
                                }
                                else {
                                    document.getElementById("showAndHideSpinner").style.display = "none";
                                    // console.log(returnVal.data.errorDetail);
                                    notify(returnVal.data.errorDetail.errorMessage);
                                }
                                document.getElementById("showAndHideSpinner").style.display = "none";
                            }

                        })
                        .catch(err => console.log("Axios err: ", err))
                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        // console.log(result.data.errorDetail);
                        notify(result.data.errorDetail.errorMessage);
                    }
                }
            })
            .catch(err => console.log("Axios err: ", err));
        } else {
            notify('Currently passenger have not added any document', 3000);
        }
        
    }

    const getVerificationIcon = (pax, td) => {
        // console.log('getVerificationIcono----', pax,td);
        // const selectedSegmentKeyArr = SearchedSelectedPassengerData.SelectedSegmentKey;
        if (td) {
            const { birthCountry, dateOfBirth, documentTypeCode, expirationDate, issuedByCode, issuedDate, name, nationality, number } = td;
            if (birthCountry !== ''
            && dateOfBirth !== ''
            && documentTypeCode !== ''
            && expirationDate !== ''
            && issuedByCode !== ''
            && issuedDate !== ''
            && nationality !== ''
            && number !== ''
            && name && name.first !== '' && name.last !== '' && name.title !== ''
            ) {
                return true
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const checkIsDocumentVerified = (documentNumber) => {
        // console.log('checkIsDocumentVerified', documentNumber, selectedPassengers[selectedPaxIndex]);
        if (documentNumber) {
            const currentPax = selectedPassengers[selectedPaxIndex];
            const td = currentPax.traveldocuments.find(t => t.number === documentNumber);
            if(getVerificationIcon(currentPax, td)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    const fncEditDocument = (travelDocument) => {
        console.log('fncEditDocument', travelDocument);
        setEditTD(true);
    }

    const getTravelDocuments = (pax, passengerPosition) => {
        return (
            // <div class='documentStepsItem'>
                // {
                    (pax.traveldocuments && pax.traveldocuments.length === 0) || pax.traveldocuments === null
                    ?
                    <div class='documentStepsItem'>
                        <div class={documentTab === 'travelDocument' ? 'documentStepsItemData active' : 'documentStepsItemData'} onClick={() => { fncDocumentTypeToShow('travelDocument') }}>
                            <span class="index font-md mid-dark-text">
                                1.
                            </span>
                            <span class="content font-md mid-dark-text">
                                Travel document required
                            </span>
                        </div>
                        <div class="documentStepsItemBtns">
                            <a class="statusIcon">
                                <img src={(pax.traveldocuments && pax.traveldocuments.length === 0) || pax.traveldocuments === null  ? 'newImages/cross-fill-icon.svg' : 'newImages/success-icon.svg'} alt={(pax.traveldocuments && pax.traveldocuments.length === 0) || pax.traveldocuments === null ? 'cross icon' : 'success icon'}/>
                            </a>
                            {/* <a class="finalIcon">
                                <img src="newImages/edit-icon.svg" alt="edit icon"/> 
                            </a> */}
                        </div>
                    </div>
                    :
                    pax.traveldocuments.map((td, i) =>
                    <div class='documentStepsItem'>
                        <div class={documentTab === 'travelDocument' && i === tdIndex ? 'documentStepsItemData active' : 'documentStepsItemData'} onClick={() => { fncDocumentTypeToShow('travelDocument', td, i, pax, passengerPosition) }}>
                            <span class="index font-md mid-dark-text">
                                {i+1}.
                            </span>
                            <span class="content font-md mid-dark-text">
                                {
                                td.documentTypeCode === 'P'
                                ? `Passport (${td.birthCountry ? `${td.birthCountry},` : ''} exp ${moment(td.expirationDate).format('DD MMM YY')})`
                                : td.documentTypeCode === 'V'
                                ? `Travel Visa (${td.birthCountry ? `${td.birthCountry},` : ''} exp ${moment(td.expirationDate).format('DD MMM YY')})`
                                : td.documentTypeCode === 'PD'
                                ? `Diplomat Passport (${td.birthCountry ? `${td.birthCountry},` : ''} exp ${moment(td.expirationDate).format('DD MMM YY')})`
                                : td.documentTypeCode === 'D'
                                ? `Diplomatic Passport (${td.birthCountry ? `${td.birthCountry},` : ''} exp ${moment(td.expirationDate).format('DD MMM YY')})`
                                : td.documentTypeCode === 'PM'
                                ? `Missionary or Service Passport (${td.birthCountry ? `${td.birthCountry},` : ''} exp ${moment(td.expirationDate).format('DD MMM YY')})`
                                : td.documentTypeCode === 'PS'
                                ? `Special Passport (${td.birthCountry ? `${td.birthCountry},` : ''} exp ${moment(td.expirationDate).format('DD MMM YY')})`
                                : td.documentTypeCode === 'SF'
                                ? `Seafarer Passport (${td.birthCountry ? `${td.birthCountry},` : ''} exp ${moment(td.expirationDate).format('DD MMM YY')})`
                                : null
                                }
                            </span>
                        </div>
                        <div class="documentStepsItemBtns">
                            <a class="statusIcon">
                                <img
                                src={getVerificationIcon(pax, td) ? 'newImages/success-icon.svg' : 'newImages/cross-fill-icon.svg'} //{(pax.traveldocuments && pax.traveldocuments.length === 0) || pax.traveldocuments === null  ? 'newImages/cross-fill-icon.svg' : 'newImages/success-icon.svg'}
                                alt={getVerificationIcon(pax, td) ? 'newImages/success-icon.svg' : 'newImages/cross-fill-icon.svg'} //{(pax.traveldocuments && pax.traveldocuments.length === 0) || pax.traveldocuments === null ? 'newImages/cross-fill-icon.svg' : 'newImages/success-icon.svg'}
                                />
                            </a>
                            <a class="finalIcon" onClick={() => { fncEditDocument('travelDocument') }}>
                                <img src="newImages/edit-icon.svg" alt="edit icon"/> 
                            </a>
                        </div>
                    </div>
                    )
                // }
                
            // </div>
        )
    }

    const getissuingCountryData = () => {
        const country = issuingCountryArray.find(ic => ic.name.toUpperCase() === issuingCountry.toUpperCase());
        return country ? `${country.name} (${country.dial_code}) (${country.code})` : '';
    }

    const getbirthCountryData = () => {
        const country = birthCountryArray.find(ic => ic.name.toUpperCase() === birthCountry.toUpperCase());
        return country ? `${country.name} (${country.dial_code}) (${country.code})` : '';
    }

    const getnationalityData = () => {
        const country = nationalityArray.find(ic => ic.name.toUpperCase() === nationality.toUpperCase());
        return country ? `${country.name} (${country.dial_code}) (${country.code})` : '';
    }

// This div was used in two places, so it has been refactored into a reusable function component.
    const BagDetail = ()=>{
        return (          
            <div className="bagDetails">
                                    {
                                        whichPassennger === ''
                                        && selectedPaxIndex !== -1
                                        && checkIsDocumentVerified(
                                            selectedPassengers[selectedPaxIndex].traveldocuments
                                            && selectedPassengers[selectedPaxIndex].traveldocuments.length
                                            && selectedPassengers[selectedPaxIndex].traveldocuments[0].number) && !editTD
                                        ?
                                        <div class={documentTab === 'travelDocument' ? 'travelDocumentVerified' : 'travelDocumentVerified d-none'}>
                                            <div class="d-flex mb-3 justify-content-between align-items-center">
                                                <div class="heading-content">
                                                    <h4 class="font-xxl bold dark-text mb-1">Travel Document</h4>
                                                    <p class="font-sm mid-dark-text mb-0">Scan document at any time</p>
                                                </div>
                                            </div>
                                            <div class="bagform">
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Document Type</p>
                                                            <p class="font-sm mb-0">
                                                                {docType ? internationalDocumentType.find(dt => dt.label === docType).label : ''}
                                                            </p>
                                                        </div>        
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Issuing Country</p>
                                                            <p class="font-sm mb-0">
                                                                {getissuingCountryData()}
                                                            </p>
                                                        </div>          
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Name on Document</p>
                                                            <p class="font-sm mb-0">{`${nameOnDocumentLast}${nameOnDocumentLast ? ',' : '' } ${nameOnDocumentFirst} ${nameOnDocumentTitle}`} </p>
                                                        </div>        
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Document Number</p>
                                                            <p class="font-sm mb-0">{docNumber}</p>
                                                        </div>        
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Expiration</p>
                                                            <p class="font-sm mb-0">{expirationDate}</p>
                                                        </div>          
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Gender</p>
                                                            <p class="font-sm mb-0">{gender}</p>
                                                        </div>        
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Birth</p>
                                                            <p class="font-sm mb-0">{dob}</p>
                                                        </div>          
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Birth Country</p>
                                                            <p class="font-sm mb-0">{getbirthCountryData()}</p>
                                                        </div>        
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class=" mb-4">
                                                            <p class="bold font-sm mb-0">Nationality</p>
                                                            <p class="font-sm mb-0">{getnationalityData()}</p>
                                                        </div>          
                                                    </div>
                                                </div>
                                                {/* <div class="d-flex">
                                                    <input class="me-2 form-check-input" type="checkbox" checked="checked" id="documentVerified" name="documentVerified" />
                                                    <label for="documentVerified" class="font-md grey-text mb-0">Document is correct & can be verified</label>
                                                </div> */}

                                            </div>
                                        </div>
                                        : 
                                        <div class={documentTab === 'travelDocument' ? 'travelDocument' : 'travelDocument d-none'}>
                                            {/* {documentTab === 'travelDocument' ? 'travelDocument' : 'travelDocument d-none'} */}
                                            <div class="d-flex mb-3 justify-content-between align-items-center">
                                                <div class="heading-content">
                                                    <h4 class="font-xxl bold dark-text mb-1">Travel Document</h4>
                                                    <p class="font-sm mid-dark-text mb-0">Scan document at any time</p>
                                                </div>
                                                <div class="heading-button-icon d-flex align-items-center">
                                                    <a class="icon-button me-2 focusClass" disabled={disableCrudButtons} onClick={() => { !disableCrudButtons && fncAddUpdateTravelDocument()}}>
                                                        <img src="newImages/reload-icon.svg" alt="icon-reload" />
                                                    </a>
                                                    <a class="icon-button  me-2" disabled={disableCrudButtons}>
                                                        <img src="newImages/block-icon.svg" alt="icon-block" />
                                                    </a>
                                                    <a class="icon-button" disabled={disableCrudButtons} onClick={() => { !disableCrudButtons && fncDeleteDocument()}}>
                                                        <img src="newImages/delete-icon.svg" alt="icon-block" />
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="bagform">
                                                {/* <div class="form-floating mb-4">
                                                        <input type="text" class="form-control" value="Mr. A Singh" id="fname" placeholder="First Name" />
                                                        <label class="bold" for="fname">Passanger Name</label>
                                                    </div> */}
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="form-floating mb-4">
                                                            <select
                                                            class="form-select focusClass"
                                                            id="documentType"
                                                            aria-label="documentType"
                                                            value={docType}
                                                            onChange={e => fncChangeDoctype(e)}
                                                            >
                                                                {
                                                                    internationalDocumentType.length ? internationalDocumentType.map((doctype, i) =>
                                                                    <option id={doctype.code} value={doctype.label}>{doctype.label}</option>
                                                                    ) : null
                                                                }
                                                            </select>
                                                            <label class="bold" for="documentType">Document Type</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="form-floating mb-4">
                                                            <select
                                                            class="form-select focusClass"
                                                            placeholder="Select issuing country"
                                                            id="issuingCountry"
                                                            value={issuingCountry}
                                                            onChange={e => fncChangeIC(e)}
                                                            aria-label="issuingCountry"
                                                            >
                                                                <option value=''>
                                                                Select Issuing Country
                                                                </option>
                                                                {
                                                                    issuingCountryArray.length ? issuingCountryArray.map((country, i) =>
                                                                    <option id={country.code} value={country.name}>{country.name}</option>
                                                                    ) : null
                                                                }
                                                            </select>
                                                            <label class="bold" for="issuingCountry">Issuing Country</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="dropdown form-dropdown mb-4">
                                                    <button class="dropdown-toggle" type="button" id="nameOnDocument" data-bs-dismiss="outside" data-bs-toggle="dropdown" aria-expanded="false">
                                                        <div class="border-bottom pb-2 w-100 ">
                                                            <p class="font-sm grey-text bold mb-1">Name on Document</p>
                                                            <p class="font-sm grey-text mb-1">{`${nameOnDocumentLast}${nameOnDocumentLast ? ',' : '' } ${nameOnDocumentFirst} ${nameOnDocumentTitle}`}</p>
                                                        </div>
                                                    </button>
                                                    <div class="dropdown-menu" aria-labelledby="nameOnDocument">
                                                        <h4 class="primary-text font-md bold mb-2">
                                                            Name on Document
                                                        </h4>
                                                        <div class="row">
                                                            <div class="col-sm-3">
                                                                <div class="form-floating mb-4">
                                                                <select
                                                                class="form-select focusClass"
                                                                id="title"
                                                                aria-label="Title"
                                                                value={updateTitle}
                                                                onChange={e => fncChangeName(e)}
                                                                >
                                                                    {
                                                                        titleArr.length ? titleArr.map((t, i) =>
                                                                        <option id='title' value={t}>{t}</option>
                                                                        ) : null
                                                                    }
                                                                </select>
                                                                    {/* <input type="text" class="form-control" value={updateTitle} onChange={e => fncChangeName(e)} id="title" placeholder="Title" /> */}
                                                                    <label class="bold" for="fname">Title</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-3">
                                                                <div class="form-floating mb-4">
                                                                    <input type="text" class="form-control focusClass" value={updateFirst} onChange={e => fncChangeName(e)} id="fname" placeholder="First Name" />
                                                                    <label class="bold" for="fname">First Name</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-3">
                                                                <div class="form-floating mb-4">
                                                                    <input type="text" class="form-control focusClass" value={updateMiddle} onChange={e => fncChangeName(e)} id="mName" placeholder="Middle Name" />
                                                                    <label class="bold" for="mName">Middle Name</label>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-3">
                                                                <div class="form-floating mb-4">
                                                                    <input type="text" class="form-control focusClass" value={updateLast} onChange={e => fncChangeName(e)} id="lName" placeholder="Last Name" />
                                                                    <label class="bold" for="lName">Last Name</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <button class="btn btn-primary me-4">
                                                                <span class="px-4" onClick={fncAdd}>Add</span>
                                                            </button>
                                                            <button class="btn btn-outline-primary">
                                                                <span class="px-3" onClick={fncClear}>Clear</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="form-floating mb-4">
                                                            <input type="text" class="form-control" value={docNumber} onChange={(e) => { fncDocNumber(e)}} id="documentNumber" placeholder="Document Number" />
                                                            <label class="bold" for="documentNumber">Document Number</label>
                                                        </div>
                                                    </div>

                                                    <div class="col-sm-6">
                                                        <div class="form-floating mb-4">
                                                            <input type="text" class="form-control" value={expirationDate} onChange={(e) => { fncChangeExpiryDate(e)}} id="expiration" placeholder="Expiration" />
                                                            <label class="bold" for="expiration">Expiration(DD/MM/YYYY)</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="form-floating mb-4">
                                                            <select
                                                            class="form-select"
                                                            id="gender"
                                                            aria-label="gender"
                                                            value={gender}
                                                            onChange={e => fncChangeGender(e)}
                                                            >
                                                                <option value=''>Select Gender</option>
                                                                <option value="Male">Male</option>
                                                                <option value="Female">Female</option>
                                                            </select>
                                                            <label class="bold" for="gender">Gender</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="form-floating date ">
                                                            <input type="text" class="form-control" id="dob" value={dob} onChange={(e) => {fncChangeDob(e)}} placeholder="DD/MM/YYYY" />

                                                            <label for="dob">Date of Birth(DD/MM/YYYY)</label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-sm-6">
                                                        <div class="form-floating mb-4">
                                                            <select
                                                            placeholder="Select birth country"
                                                            class="form-select"
                                                            id="birthCountry"
                                                            aria-label="birthCountry"
                                                            value={birthCountry}
                                                            onChange={e => fncChangeBC(e)}
                                                            >
                                                                <option value=''>
                                                                Select Birth Country
                                                                </option>
                                                                {
                                                                    birthCountryArray.length ? birthCountryArray.map((country, i) =>
                                                                    <option id={country.code} value={country.name}>{country.name}</option>
                                                                    ) : null
                                                                }
                                                            </select>
                                                            <label class="bold" for="birthCountry">Birth Country</label>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-6">
                                                        <div class="form-floating mb-4">
                                                            <select
                                                            class="form-select"
                                                            placeholder="Select nationality"
                                                            id="nationality"
                                                            aria-label="nationality"
                                                            value={nationality}
                                                            onChange={e => fncChangeNationality(e)}
                                                            >
                                                                <option value=''>
                                                                Select Nationality
                                                                </option>
                                                                {
                                                                    nationalityArray.length ? nationalityArray.map((country, i) =>
                                                                    <option id={country.code} value={country.name}>{country.name}</option>
                                                                    ) : null
                                                                }
                                                            </select>
                                                            <label class="bold" for="nationality">Nationality</label>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* <div class="d-flex">
                                                    <input
                                                    class="me-2 form-check-input"
                                                    checked={isDocVerified}
                                                    onChange={(e) => { fncDocVerification(e) }}
                                                    type="checkbox"
                                                    id="documentVerified"
                                                    name="documentVerified"
                                                    />
                                                    <label for="documentVerified" class="font-md grey-text mb-0">Document is correct & can be verified</label>
                                                </div> */}

                                            </div>
                                        </div>
                                    }
                                    <div class={documentTab === 'inTransitDetails' ? 'inTransitDetails' : 'inTransitDetails d-none'}>
                                        <div class="heading-content mb-3">
                                            <h4 class="font-xxl bold dark-text mb-1">
                                                In-Transit Details
                                            </h4>
                                        </div>
                                        <div class="inTransitDetails-content">
                                            <p class="font-md mid-dark-text bold">Is passenger in transit at destination?</p>
                                            <div class="d-flex align-items-center m-2">
                                                <input
                                                    class="me-2"
                                                    type="radio"
                                                    id="inTransitYes"
                                                    // name="inTransit"
                                                    value="Yes"
                                                    checked={inTransit === 'Yes'}
                                                    onChange={handleInTransitChange}
                                                />
                                                <label className="mb-0" for="inTransitYes">Yes</label>
                                            </div>
                                            <div class="d-flex align-items-center m-2">
                                                <input
                                                class="me-2"
                                                    type="radio"
                                                    id="inTransitNo"
                                                    // name="inTransit"
                                                    checked={inTransit === 'No'} 
                                                    value="No"
                                                    onChange={handleInTransitChange}
                                                />
                                                <label className="mb-0" for="inTransitNo">No</label>
                                            </div>
                                        </div>

                                    </div>
                                    <div class={documentTab === 'countryOfResidenceDetails' ? 'countryOfResidenceDetails' : 'countryOfResidenceDetails d-none'}>
                                        <div class="heading-content mb-3">
                                            <h4 class="font-xxl bold dark-text mb-1">
                                                Country of Residence
                                    </h4>
                                        </div>
                                        <div class="country-of-resident-details-content">
                                            <div class="form-floating mb-4">
                                                <select
                                                    class="form-select"
                                                    id="residentOf"
                                                    aria-label="residentOf"
                                                    value={countryofResidence}
                                                    onChange={e => fncChangeCOR(e)}
                                                >
                                                    {
                                                        countryOfResidenceArray.length ? countryOfResidenceArray.map((country, i) =>
                                                        <option id={country.code} value={country.name}>{country.name}</option>
                                                        ) : null
                                                    }
                                                   </select>
                                                <label class="bold" for="residentOf">Resident of</label>
                                            </div>
                                            <div class="form-floating mb-4">
                                                <select
                                                    class="form-select"
                                                    id="appliesTo"
                                                    aria-label="appliesTo"
                                                    value={currentPax.name ? `${currentPax.name.last}, ${currentPax.name.first} ${currentPax.name.title ? currentPax.name.title : ''}` : ''}
                                                >
                                                    <option value=
                                                    {
                                                        currentPax.name ? `${currentPax.name.last}, ${currentPax.name.first} ${currentPax.name.title ? currentPax.name.title : ''}` : ''
                                                    }
                                                    >
                                                        {currentPax.name ? `${currentPax.name.last}, ${currentPax.name.first} ${currentPax.name.title ? currentPax.name.title : ''}` : ''}
                                                    </option>
                                                </select>
                                                <label class="bold" for="appliesTo">Applies to:</label                     >
                                            </div>

                                        </div>
                                    </div>
        </div>
             )
    }
   
    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <DocumentVerificationModal trigger={!isInternationalFlight(SearchedFlightDetails) && selectedModule === checkinModule && !docVerified && !allCheckedIn && haveTravelDocs(SearchedFlightDetails)}></DocumentVerificationModal>
            <div class="full-container">
                <div class="seat-container">
                    <div class="row">
                        <div class="col-lg-8">
                            <div class="leftDetail-data">
                                <div class="pTable-data-outer bagData">
                                    <div class="heading border-bottom mb-3">
                                        <h4 class="font-xxl bold dark-text mb-0">
                                            Security
                                        </h4>
                                        {/* <button class="btn btn-secondary" onClick={fncConnectScanner}>
                                            <span class="px-4"> Connect Scanner<span class="icon ms-2"></span></span>
                                        </button> */}
                                    </div>
                                    <div class="security-checklist mb-3 d-flex align-items-center border-bottom pb-2">
                                        <div class="security-checklist-input  w-100 ">
                                            <h4 class="font-xxl bold dark-text mb-0">
                                                Security <span class="font-md regular">(General)</span>
                                            </h4>
                                        </div>
                                        {/* <button class="btn btn-secondary" onClick={fncConnectScanner}>
                                            <span class="px-4"> Connect Scanner<span class="icon ms-2"></span></span>
                                        </button> */}
                                        <a
                                        data-bs-dismiss="modal"
                                        data-bs-toggle="modal"
                                        data-bs-target="#addNewSecurity"
                                        class="btn btn-outline-primary btn-animation ps-2 ms-4 d-flex align-items-center insert-btn"
                                        >
                                            <img
                                            class="mr-1 icon-24"
                                            src="newImages/add-icon.svg"
                                            alt="add icon"
                                            />
                                            Add New Security Item
                                        </a>
                                    </div>
                                    <h4 class="font-lg bold primary-text mb-3">General</h4>
                                    <div class="pTable border-t-1">
                                        <div class="accordion pTableAccordion" id="accordionExample">
                                            {
                                                selectedPassengers.length
                                                    ?
                                                    selectedPassengers.map((pax, i) =>
                                                        pax.IsSelected ?
                                                            <div class="accordion-item">
                                                                <h2 class="accordion-header" id={`heading${pax.name ? pax.name.first: ''}`}>
                                                                    <a class="accordion-button" onClick={() => fncChangeCurrentPax(i)} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${pax.name ? pax.name.first: ''}`} aria-expanded="true" aria-controls={`collapse${pax.name ? pax.name.first: ''}`}>
                                                                    {pax.name ? `${pax.name.last}, ${pax.name.first} ${pax.name.title ? pax.name.title : ''}` : ''} {pax.associatedWithPassenger ? '(Infant)' : ''}
                                                                    </a>
                                                                    <a data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#newService" class="addNewBag-btn d-lg-none d-inline-block btn-primary">
                                                                        Travel Document
                                                                    </a>
                                                                </h2>
                                                                <div id={`collapse${pax.name ? pax.name.first : ''}`} class={i === selectedPaxIndex ? "accordion-collapse collapse show": "accordion-collapse collapse" } aria-labelledby={`heading${pax.name ? pax.name.first : ''}`} data-bs-parent="#accordionExample">
                                                                    <div class="accordion-body">
                                                                        <div class="documentSteps">
                                                                            {getTravelDocuments(pax, i)}
                                                                            <div class='documentStepsItem'>
                                                                                <div class={documentTab === 'inTransitDetails' ? 'documentStepsItemData active' : 'documentStepsItemData'} onClick={() => { fncDocumentTypeToShow('inTransitDetails') }}>
                                                                                    <span class="index font-md mid-dark-text">
                                                                                        {pax.traveldocuments && pax.traveldocuments.length+1}.
                                                                                    </span>
                                                                                    <span class="content font-md mid-dark-text">
                                                                                        In-Transit details required 
                                                                                    </span>
                                                                                </div>
                                                                                <div class="documentStepsItemBtns">
                                                                                    <a class="statusIcon">
                                                                                        <img
                                                                                        src={(inTransit === 'Yes' || inTransit === 'No') ? 'newImages/success-icon.svg' : 'newImages/cross-fill-icon.svg'}
                                                                                        alt= {(inTransit === 'Yes' || inTransit === 'No') ? 'success icon' : 'cross icon'}/> 
                                                                                    </a>
                                                                                    <a class="finalIcon">
                                                                                        <img src="newImages/edit-icon.svg" alt="edit icon"/> 
                                                                                    </a>
                                                                                
                                                                                </div>
                                                                            </div>
                                                                            <div class='documentStepsItem'>
                                                                                <div class={documentTab === 'countryOfResidenceDetails' ? 'documentStepsItemData active' : 'documentStepsItemData'} onClick={() => { fncDocumentTypeToShow('countryOfResidenceDetails') }}>
                                                                                    <span class="index font-md mid-dark-text">
                                                                                    {pax.traveldocuments && pax.traveldocuments.length+2}.
                                                                                    </span>
                                                                                    <span class="content font-md mid-dark-text">
                                                                                        Country of residence required
                                                                                    </span>
                                                                                </div>
                                                                                <div class="documentStepsItemBtns">
                                                                                    <a class="statusIcon">
                                                                                        <img src="newImages/cross-fill-icon.svg" alt="cross icon"/> 
                                                                                    </a>
                                                                                    <a class="finalIcon">
                                                                                        <img src="newImages/edit-icon.svg" alt="edit icon"/> 
                                                                                    </a>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div> : ''
                                                    )
                                                    : null
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4 d-none d-lg-block">
                            <div class="rightDetail-data bagDetails-data">
                               { BagDetail()}
                            </div>
                        </div>
                    </div>
                    <div class="btn-container">
                        <a class="btn btn-primary-dark" onClick={() => history.goBack()}>
                            <span class="px-4"><span class="icon me-2"><img class=" rotate180" src="newImages/i-arrow-right.svg" /> <img class=" rotate180" src="newImages/i-arrow-right.svg" /></span>Previous</span>
                        </a>
                        <button class="btn btn-secondary" disabled={isNextDisabled} onClick={fncNextSecurity}>
                            <span class="px-4"> Next<span class="icon ms-2"><img src="newImages/i-arrow-right.svg" /> <img src="newImages/i-arrow-right.svg" /></span></span>
                        </button>
                    </div>
                </div>
            </div>
            {/* add security modal */}
            <div
            class="modal fade"
            id="addNewSecurity"
            tabindex="-1"
            aria-labelledby="staticBackdropLabel"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-dismiss="modal"
            data-toggle="modal"
            >
            <div class="modal-dialog modal-dialog-centered security-modal seat-modal">
                <div class="modal-content">
                <div class="bagDetails">
                    <div class="">
                    <div
                        class="d-flex mb-3 justify-content-between align-items-center"
                    >
                        <div class="heading-content">
                        <h4 class="semibold font-lg primary-text mb-1">
                            Add New Security Item
                        </h4>
                        </div>
                    </div>
                    <div class="bagform">
                        <div class="row">
                        <div class="col-lg-12">
                            <div class="form-floating mb-3">
                            <select
                                class="form-select"
                                id="likeToAdd"
                                aria-label="likeToAdd"
                            >
                                {/* <option>Select</option> */}
                                <option value="">Travel Document</option>
                            </select>

                            <label class="font-md bold dark-text" for="likeToAdd"
                                >What would you like to add?
                            </label>
                            </div>
                        </div>
                        </div>

                        <div class="row">
                        <div class="col-lg-12">
                            <div class="form-floating mb-3">
                            <select
                                class="form-select"
                                id="whichPassenger"
                                aria-label="whichPassenger"
                                value={whichPassennger}
                                onChange={e => fncChangeCurrentPaxFromPopup(e)}
                            >
                                <option>Select Passenger</option>
                                {
                                    selectedPassengers.length ? selectedPassengers.map((pax, i) =>
                                    <option
                                    // id={i}
                                    value={pax.name ? `${pax.name.last}, ${pax.name.first} ${pax.name.title ? pax.name.title : ''}` : ''}>
                                        {pax.name ? `${pax.name.last}, ${pax.name.first} ${pax.name.title ? pax.name.title : ''}` : ''}
                                    </option>
                                    ) : null
                                }
                            </select>
                            <label
                                class="font-md bold dark-text"
                                for="whichPassenger"
                                >For which passenger?
                            </label>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div class="btn-container d-flex">
                        <a
                        data-bs-dismiss="modal"
                        onClick={fncAddPassengerFromPopup}
                        class="btn-add btn btn-primary btn-animation d-flex justify-content-center"
                        >
                        <span class="font-md bold">Add</span>
                        </a>
                        <a
                        data-bs-dismiss="modal"
                        onClick={fncCancelPopup}
                        class="btn-cancel btn btn-outline-primary btn-animation d-flex justify-content-center"
                        >
                        <span class="font-md bold" >Cancel</span>
                        </a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
            {/* seat modal */}
            <div class="modal fade " id="newService" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true" data-bs-backdrop="static" data-dismiss="modal" data-toggle="modal">
                <div class="modal-dialog modal-dialog-centered seat-modal">
                    <div class="modal-content pb-3 ps-3">
                        { BagDetail()}
                        <div class="closebtn-container ">
                            <a data-bs-dismiss="modal" class="btn btn-primary-dark">
                                <span class="px-4">Close</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Security;